import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
// material
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
// icons-material
import Logout from '@mui/icons-material/Logout';
import MoreIcon from '@mui/icons-material/MoreVert';
import MenuOpen from '@mui/icons-material/MenuOpen';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Brightness6 from '@mui/icons-material/Brightness6';
import DarkMode from '@mui/icons-material/DarkMode';
import Search from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';

import thana_logo from "../../picture/logo/thana_logo.png";
// component
import { api_ip } from '../../api/axios';
//import localStore from '../../pages/localStore';
// Drawer for left menu
import Drawer from './menu/Drawer';
import useAuth from '../../auth_services/useAuth';
import { ThemeContext } from "../../Theme";

function ElevationScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

export default function PrimaryAppBar(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const { theme, toggleTheme, modeTitle } = useContext(ThemeContext);

    const axiosPrivate = useAxiosPrivate();

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const [user, setUser] = useState({
        name: '',
        username: '',
        role: '',
        filename: ''
    });
    useEffect(() => {
        setUser({
            name: useAuth.Name(),
            username: useAuth.userName(),
            role: useAuth.role(),
            filename: useAuth.userImage()
        });
    }, [props.profileupdate]);

    // Call form show merchant name
    useEffect(() => {
        if (useAuth.GetToken() == null) {
            navigate('/login');
        }
    }, [location.pathname]);

    // Image path
    let imgPath = api_ip() + "/profile/image/";
    const getProfileImage = () => {
        if (useAuth.GetToken() != null && useAuth.userImage() != undefined && useAuth.userImage() != '') {
            return imgPath + useAuth.userImage();
        }
    }

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = (url) => {
        setAnchorEl(null);
        navigate(url);
        handleMobileMenuClose();

        if (url === '/logout') {
            logout();
        }
    };

    const logout = async () => {
        try {
            useAuth.Logout();
            navigate("/login");
        } catch (error) {
            console.log(error);
        }
    }

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            id={menuId}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.menu',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                    bgcolor: 'background.menu',
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={() => { handleMenuClose('/profile') }}><AccountCircle /> &nbsp; ຂໍ້ມູນສ່ວນຕົວ</MenuItem>
            <MenuItem onClick={() => { handleMenuClose('/logout') }}><Logout /> &nbsp; ອອກຈາກລະບົບ</MenuItem>
        </Menu >
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem
                onClick={() => {
                    toggleTheme();
                }}
            >
                {
                    theme === 'dark' ? (

                        <Brightness6 />

                    ) : (

                        <DarkMode />

                    )

                }
                <p> &nbsp; {modeTitle()}</p>
            </MenuItem>
            <MenuItem onClick={() => { handleMenuClose('/profile') }}>
                <Avatar
                    alt="Remy Sharp"
                    src={getProfileImage()}
                    sx={{ marginTop: '0px', width: 30, height: 30 }}
                    onClick={() => { handleMenuClose('/profile') }}
                    className='cursor-pointer'
                />
                &nbsp; ຂໍ້ມູນສ່ວນຕົວ
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => { handleMenuClose('/logout') }}><Logout /> &nbsp; ອອກຈາກລະບົບ</MenuItem>
        </Menu>
    );

    return (
        <Box sx={{
            flexGrow: 1,
            boxShadow: 1
        }}>
            {/*<ElevationScroll {...props}>*/}
            <AppBar
                elevation={0}
                sx={{
                    '&.MuiAppBar-root': {
                        backgroundColor: 'background.leftmenu',
                        color: 'text.primary',
                        //color: '#ffffff'
                    },
                    '.css-1hnxwkd-MuiPaper-root-MuiAppBar-root': {
                        backgroundImage: ''
                    },
                    '.css-hyum1k-MuiToolbar-root': {
                        '@media screen and (max-width: 900px)': {
                            paddingLeft: '0px',
                            paddingRight: '0px'
                        },
                    },
                    borderColor: 'boderColor.line',
                    borderStyle: 'solid',
                    borderWidth: '0px 0px 1px 0px'
                }}>

                <Toolbar
                //variant="dense"
                >
                    {/* resize menu to small menu */}
                    <Box
                        sx={{
                            marginLeft: '-13px',
                            '@media screen and (max-width: 1400px)': {
                                display: 'none',
                            },
                        }}
                    >
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            sx={{ mr: 2, marginLeft: '5px' }}
                            onClick={() => {
                                if (props.menuSmall == 'large') {
                                    props.setMenuSmall('small');
                                    // set leftMenuResize
                                    localStorage.setItem("leftMenuResize", 'small');
                                } else {
                                    props.setMenuSmall('large');
                                    // set leftMenuResize
                                    localStorage.setItem("leftMenuResize", 'large');
                                }
                            }}
                        >
                            <Tooltip title="">
                                {props.menuSmall == 'large' ? (
                                    <MenuOpen />
                                ) : (
                                    <MenuIcon />
                                )}
                            </Tooltip>

                        </IconButton>
                    </Box>

                    {/* Call drawer menu*/}
                    <Box
                        sx={{
                            '@media screen and (min-width: 1401px)': {
                                display: 'none',
                            },
                            '@media screen and (min-width: 900px)': {
                                marginLeft: '-13px',
                            },
                        }}
                    >
                        <Drawer
                            prdOutofStockCount={props.prdOutofStockCount}
                            prdExpireSoonCount={props.prdExpireSoonCount}
                            merchantVal={props.merchantVal}
                            mainMenuActive={props.mainMenuActive}
                            menuActive={props.menuActive}
                        />
                    </Box>

                    <Box
                        sx={{
                            height: '80px',
                            marginLeft: '-30px',
                            marginTop: '-15px',
                            backgroundColor: 'background.leftmenu',
                            padding: '25px 0px 0px 20px',
                            width: '300px',
                            color: 'text.fixed',
                            fontSize: '33px',
                            fontWeight: '800'
                        }}
                    >
                        <Box sx={{ color: 'text.fixed' }}>
                            <img style={{ width: '100px' }} alt="" src={thana_logo} />
                        </Box>
                    </Box>

                    <Box sx={{ flexGrow: 0.4 }} />

                    <Box
                        sx={{
                            width: '100%',
                            display: { xs: 'none', md: 'flex' },
                            display: 'flex',
                            justifyContent: 'right',
                            flex: 1,
                            paddingRight: '5px',
                            backgroundColor: 'background.table',
                            borderRadius: '20px'
                        }}
                    >
                        <TextField
                            id="outlined-basic"
                            label=""
                            size='small'
                            placeholder='ຄົ້ນຫາ'
                            variant="outlined"
                            sx={{
                                '& fieldset': {
                                    borderRadius: '20px'
                                },
                            }}
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                            }}
                        />
                    </Box>

                    <Box sx={{ flexGrow: 0.6 }} />

                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Tooltip title={modeTitle()}>
                            <IconButton
                                size="large"
                                aria-label="show 17 new notifications"
                                color="inherit"
                                onClick={() => {
                                    toggleTheme();
                                }}
                            >
                                {theme === 'dark' ? (
                                    <Brightness6 />
                                ) : (
                                    <DarkMode />
                                )}
                            </IconButton>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title='ຂໍ້ມູນສ່ວນຕົວ'>
                            {user.filename != 'fileNull' ? (
                                <Avatar
                                    alt="Remy Sharp"
                                    src={getProfileImage()}
                                    sx={{ marginTop: '5px', width: 40, height: 40 }}
                                    onClick={() => { handleMenuClose('/profile') }}
                                    className='cursor-pointer'
                                />
                            ) : (
                                <Avatar sx={{ marginTop: '5px', width: 40, height: 40 }} onClick={() => { handleMenuClose('/profile') }}>
                                    <PersonIcon />
                                </Avatar>
                            )}
                        </Tooltip>
                        &nbsp;
                        <Tooltip title='ຊື່ຜູ້ໃຊ້ງານ'>
                            <Box
                                sx={{ marginTop: '-3px', fontSize: '12px', display: { xs: 'none', md: 'block' } }}
                                onClick={() => { handleMenuClose('/profile') }}
                                className='cursor-pointer'
                            >
                                <Box style={{ fontWeight: 'bold' }}>{user.name}</Box>
                                <Box>{user.username}</Box>
                                <Box>{user.role}</Box>
                            </Box>
                        </Tooltip>

                    </Box>
                    { /* for show more icon when windows resize to min*/}

                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >

                            <MoreIcon />

                        </IconButton>
                    </Box>

                </Toolbar>
            </AppBar>
            {/*</ElevationScroll>*/}
            {renderMobileMenu}
            {renderMenu}
        </Box >
    );
}